import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option", "property", "objectTypeId"];
import { useMemo, memo } from 'react';
import I18n from 'I18n';
import { makeOptionsFromProperty, makeOptionsFromPropertyWithoutBlankOptions } from 'customer-data-property-utils/PropertyValueDisplay';
import UISelect from 'UIComponents/input/UISelect';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { PriorityStatusDot } from '../utils/PriorityStatusDot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Component used to render each option in the select.
 */
const OptionWithStatusDot = _ref => {
  let {
      children,
      option,
      property,
      objectTypeId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!option.value) {
    return /*#__PURE__*/_jsx("li", Object.assign({}, rest, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsxs("li", Object.assign({
    style: {
      padding: '8px 20px'
    }
  }, rest, {
    children: [/*#__PURE__*/_jsx(PriorityStatusDot, {
      property: property,
      objectTypeId: objectTypeId,
      value: option.value
    }), option.text]
  }));
};
/**
 * Helper used to render the currently-selected value.
 */
const renderValueWithStatusDot = ({
  value,
  text,
  buttonText
}, property, objectTypeId) => {
  if (!value) {
    return buttonText;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(PriorityStatusDot, {
      property: property,
      objectTypeId: objectTypeId,
      value: value
    }), text]
  });
};
const PropertyInputPriority = props => {
  const {
    defaultValue,
    inputRef,
    isRequired,
    placeholder,
    property,
    value,
    objectTypeId
  } = props;
  const selectPlaceholder = useMemo(() => {
    if (placeholder !== undefined) {
      return placeholder || '';
    }
    return (
      // @ts-expect-error it's possible Tasks is still passing 'placeholder' as a field on the property record and expecting it to work
      property.placeholder || I18n.text('customerDataProperties.PropertyInput.selectPlaceholder')
    );
  }, [property, placeholder]);
  const selectValue = String(value || defaultValue || '');
  const selectOptions = useMemo(() => {
    return isRequired ? makeOptionsFromPropertyWithoutBlankOptions(property) : makeOptionsFromProperty(property);
  }, [property, isRequired]);
  const OptionComponent = useMemo(() => {
    return statusProps => /*#__PURE__*/_jsx(OptionWithStatusDot, Object.assign({}, statusProps, {
      property: property,
      objectTypeId: objectTypeId
    }));
  }, [property, objectTypeId]);
  const UIDotComponent = useMemo(() => {
    return selectOption => renderValueWithStatusDot(selectOption, property, objectTypeId);
  }, [property, objectTypeId]);
  return /*#__PURE__*/_jsx(UISelect, Object.assign({}, getTransferrableProps(props, ['onFocus', 'onKeyUp']), {
    options: selectOptions,
    placeholder: selectPlaceholder,
    ref: inputRef,
    value: selectValue,
    itemComponent: OptionComponent,
    valueRenderer: UIDotComponent
  }));
};
export default /*#__PURE__*/memo(PropertyInputPriority);